export default {
  // 同IP用户预警
  'riskDimension.ip.title': '同IP用户预警',
  'riskDimension.ip.ipAddress': 'IP地址',
  'riskDimension.ip.ipAddressPlaceholder': '请输入IP地址',
  'riskDimension.ip.memberAccount': '用户名',
  'riskDimension.ip.memberAccountPlaceholder': '请输入用户名',
  'riskDimension.ip.minMemberCount': '同维度关联数量 ≥',
  'riskDimension.ip.minMemberCountPlaceholder': '请输入',
  'riskDimension.ip.minRiskCount': '已风控数量 ≥',
  'riskDimension.ip.minRiskCountPlaceholder': '请输入',
  'riskDimension.ip.query': '查询',
  'riskDimension.ip.reset': '重置',
  'riskDimension.ip.export': '导出',
  
  // 表格列
  'riskDimension.ip.table.ipAddress': 'IP地址',
  'riskDimension.ip.table.totalMembers': '同维度用户数',
  'riskDimension.ip.table.riskMembers': '已风控数量',
  'riskDimension.ip.table.details': '详情',
  'riskDimension.ip.table.lastUpdateTime': '最后更新时间',
  'riskDimension.ip.table.action': '操作',
  'riskDimension.ip.table.view': '查看',
  'riskDimension.ip.table.expand': '展开',
  'riskDimension.ip.table.more': '更多',
  'riskDimension.ip.table.total': '共 {total} 条记录',
  
  // 快速查看弹窗
  'riskDimension.ip.quickView.title': '关联用户列表',
  'riskDimension.ip.quickView.ipLabel': 'IP地址',
  'riskDimension.ip.quickView.searchPlaceholder': '搜索用户账号',
  'riskDimension.ip.quickView.noResults': '未找到匹配的账号',
  'riskDimension.ip.quickView.showing': '显示',
  
  // 详情弹窗
  'riskDimension.ip.detail.title': 'IP地址',
  'riskDimension.ip.detail.summary': '该IP地址下共有 {total} 名用户，其中已设置风控 {risk} 名',
  'riskDimension.ip.detail.batchSetRisk': '批量设置风控等级',
  'riskDimension.ip.detail.searchPlaceholder': '搜索用户名',
  'riskDimension.ip.detail.search': '搜索',
  'riskDimension.ip.detail.select': '选择',
  'riskDimension.ip.detail.memberAccount': '用户名',
  'riskDimension.ip.detail.currentRisk': '当前风控识别',
  'riskDimension.ip.detail.setRiskLevel': '设置风控等级',
  'riskDimension.ip.detail.batchSetPending': '批量设置风控等级功能待实现',
  
  // 风控等级
  'riskDimension.riskLevel.limitLogin': '限制登录',
  'riskDimension.riskLevel.limitDeposits': '限制存款',
  'riskDimension.riskLevel.limitWithdrawal': '限制提款',
  'riskDimension.riskLevel.limitDiscount': '限制优惠',
  'riskDimension.riskLevel.potentialRisk': '潜在风险',
  'riskDimension.riskLevel.sameIp': '同IP风控',
  'riskDimension.riskLevel.sameDevice': '同设备风控',
  'riskDimension.riskLevel.sameBankCard': '同银行卡风控',
  'riskDimension.riskLevel.sameWallet': '同钱包风控',
  
  // 设置风控等级弹窗
  'riskDimension.setRisk.title': '设置风控等级',
  'riskDimension.setRisk.batchTitle': '批量设置风控等级',
  'riskDimension.setRisk.members': '个用户',
  'riskDimension.setRisk.riskLevel': '风控等级',
  'riskDimension.setRisk.selectPlaceholder': '请选择风控等级',
  'riskDimension.setRisk.loginLimitType': '登录限制类型',
  'riskDimension.setRisk.loginLimitTypePlaceholder': '请选择登录限制类型',
  'riskDimension.setRisk.loginLimitTypeRequired': '请选择登录限制类型',
  'riskDimension.setRisk.remark': '备注',
  'riskDimension.setRisk.remarkPlaceholder': '请输入备注信息',
  'riskDimension.setRisk.confirm': '确定',
  'riskDimension.setRisk.cancel': '取消',
  'riskDimension.setRisk.success': '风控等级设置成功',
  'riskDimension.setRisk.batchSuccess': '批量设置成功，共更新 {count} 个用户',
  'riskDimension.setRisk.error': '风控等级设置失败',
  'riskDimension.setRisk.missingMemberId': '缺少会员ID，无法设置风控等级',
  
  // 详情弹窗
  'riskDimension.ip.detail.selectMembersFirst': '请先选择用户',
  
  // 消息提示
  'riskDimension.message.queryFailed': '查询失败',
  'riskDimension.message.queryMemberListFailed': '查询用户列表失败',
  'riskDimension.message.exportLoading': '导出任务创建中，请稍候...',
  'riskDimension.message.exportSuccess': '导出任务创建成功，请到下载列表查看',
  'riskDimension.message.exportFailed': '导出失败',
  
  // 同设备用户预警
  'riskDimension.device.title': '同设备用户预警',
  'riskDimension.device.deviceId': '设备ID',
  'riskDimension.device.deviceIdPlaceholder': '请输入设备ID',
  'riskDimension.device.memberAccount': '用户名',
  'riskDimension.device.memberAccountPlaceholder': '请输入用户名',
  'riskDimension.device.minMemberCount': '同维度关联数量 ≥',
  'riskDimension.device.minMemberCountPlaceholder': '请输入',
  'riskDimension.device.minRiskCount': '已风控数量 ≥',
  'riskDimension.device.minRiskCountPlaceholder': '请输入',
  'riskDimension.device.query': '查询',
  'riskDimension.device.reset': '重置',
  'riskDimension.device.export': '导出',
  'riskDimension.device.table.deviceId': '设备ID',
  'riskDimension.device.table.totalMembers': '同维度用户数',
  'riskDimension.device.table.riskMembers': '已风控数量',
  'riskDimension.device.table.details': '详情',
  'riskDimension.device.table.lastUpdateTime': '最后更新时间',
  'riskDimension.device.table.action': '操作',
  'riskDimension.device.table.view': '查看',
  'riskDimension.device.table.more': '更多',
  'riskDimension.device.table.total': '共 {total} 条记录',
  'riskDimension.device.detail.title': '设备ID',
  'riskDimension.device.detail.summary': '该设备下共有 {total} 名用户，其中已设置风控 {risk} 名',
  'riskDimension.device.detail.batchSetRisk': '批量设置风控等级',
  'riskDimension.device.detail.searchPlaceholder': '搜索用户名',
  'riskDimension.device.detail.search': '搜索',
  'riskDimension.device.detail.memberAccount': '用户名',
  'riskDimension.device.detail.currentRisk': '当前风控识别',
  'riskDimension.device.detail.setRiskLevel': '设置风控等级',
  'riskDimension.device.detail.selectMembersFirst': '请先选择用户',
  'riskDimension.device.quickView.title': '关联用户列表',
  'riskDimension.device.quickView.deviceLabel': '设备ID',
  'riskDimension.device.quickView.searchPlaceholder': '搜索用户账号',
  'riskDimension.device.quickView.noResults': '未找到匹配的账号',
  'riskDimension.device.quickView.showing': '显示',
  
  // 同银行卡用户预警  
  'riskDimension.bank.title': '同银行卡用户预警',
  'riskDimension.bank.bankCard': '银行卡号',
  'riskDimension.bank.bankCardPlaceholder': '请输入银行卡号',
  'riskDimension.bank.bankAccountName': '银行户名',
  'riskDimension.bank.bankAccountNamePlaceholder': '请输入银行户名',
  'riskDimension.bank.memberAccount': '用户名',
  'riskDimension.bank.memberAccountPlaceholder': '请输入用户名',
  'riskDimension.bank.minMemberCount': '同维度关联数量 ≥',
  'riskDimension.bank.minMemberCountPlaceholder': '请输入',
  'riskDimension.bank.minRiskCount': '已风控数量 ≥',
  'riskDimension.bank.minRiskCountPlaceholder': '请输入',
  'riskDimension.bank.query': '查询',
  'riskDimension.bank.reset': '重置',
  'riskDimension.bank.export': '导出',
  'riskDimension.bank.table.bankCard': '银行卡号',
  'riskDimension.bank.table.bankAccountName': '银行户名',
  'riskDimension.bank.table.totalMembers': '同维度用户数',
  'riskDimension.bank.table.riskMembers': '已风控数量',
  'riskDimension.bank.table.details': '详情',
  'riskDimension.bank.table.lastUpdateTime': '最后更新时间',
  'riskDimension.bank.table.action': '操作',
  'riskDimension.bank.table.view': '查看',
  'riskDimension.bank.table.more': '更多',
  'riskDimension.bank.table.total': '共 {total} 条记录',
  'riskDimension.bank.detail.title': '银行卡号',
  'riskDimension.bank.detail.summary': '该银行卡下共有 {total} 名用户，其中已设置风控 {risk} 名',
  'riskDimension.bank.detail.batchSetRisk': '批量设置风控等级',
  'riskDimension.bank.detail.searchPlaceholder': '搜索用户名',
  'riskDimension.bank.detail.search': '搜索',
  'riskDimension.bank.detail.memberAccount': '用户名',
  'riskDimension.bank.detail.currentRisk': '当前风控识别',
  'riskDimension.bank.detail.setRiskLevel': '设置风控等级',
  'riskDimension.bank.detail.selectMembersFirst': '请先选择用户',
  'riskDimension.bank.quickView.title': '关联用户列表',
  'riskDimension.bank.quickView.bankCardLabel': '银行卡号',
  'riskDimension.bank.quickView.searchPlaceholder': '搜索用户账号',
  'riskDimension.bank.quickView.noResults': '未找到匹配的账号',
  'riskDimension.bank.quickView.showing': '显示',
  
  // 同钱包用户预警
  'riskDimension.wallet.title': '同钱包用户预警',
  'riskDimension.wallet.walletNumber': '钱包号码',
  'riskDimension.wallet.walletNumberPlaceholder': '请输入钱包号码',
  'riskDimension.wallet.walletType': '钱包类型',
  'riskDimension.wallet.walletTypePlaceholder': '请选择钱包类型',
  'riskDimension.wallet.walletType.USDT': 'USDT',
  'riskDimension.wallet.walletType.BTC': 'BTC',
  'riskDimension.wallet.walletType.ETH': 'ETH',
  'riskDimension.wallet.walletType.OTHER': '其他',
  'riskDimension.wallet.memberAccount': '用户名',
  'riskDimension.wallet.memberAccountPlaceholder': '请输入用户名',
  'riskDimension.wallet.minMemberCount': '同维度关联数量 ≥',
  'riskDimension.wallet.minMemberCountPlaceholder': '请输入',
  'riskDimension.wallet.minRiskCount': '已风控数量 ≥',
  'riskDimension.wallet.minRiskCountPlaceholder': '请输入',
  'riskDimension.wallet.query': '查询',
  'riskDimension.wallet.reset': '重置',
  'riskDimension.wallet.export': '导出',
  'riskDimension.wallet.table.walletNumber': '钱包号码',
  'riskDimension.wallet.table.walletType': '钱包类型',
  'riskDimension.wallet.table.totalMembers': '同维度用户数',
  'riskDimension.wallet.table.riskMembers': '已风控数量',
  'riskDimension.wallet.table.details': '详情',
  'riskDimension.wallet.table.lastUpdateTime': '最后更新时间',
  'riskDimension.wallet.table.action': '操作',
  'riskDimension.wallet.table.view': '查看',
  'riskDimension.wallet.table.more': '更多',
  'riskDimension.wallet.table.total': '共 {total} 条记录',
  'riskDimension.wallet.detail.title': '钱包号码',
  'riskDimension.wallet.detail.summary': '该钱包下共有 {total} 名用户，其中已设置风控 {risk} 名',
  'riskDimension.wallet.detail.batchSetRisk': '批量设置风控等级',
  'riskDimension.wallet.detail.searchPlaceholder': '搜索用户名',
  'riskDimension.wallet.detail.search': '搜索',
  'riskDimension.wallet.detail.memberAccount': '用户名',
  'riskDimension.wallet.detail.currentRisk': '当前风控识别',
  'riskDimension.wallet.detail.setRiskLevel': '设置风控等级',
  'riskDimension.wallet.detail.selectMembersFirst': '请先选择用户',
  'riskDimension.wallet.quickView.title': '关联用户列表',
  'riskDimension.wallet.quickView.walletNumberLabel': '钱包号码',
  'riskDimension.wallet.quickView.searchPlaceholder': '搜索用户账号',
  'riskDimension.wallet.quickView.noResults': '未找到匹配的账号',
  'riskDimension.wallet.quickView.showing': '显示',
};

